import React, { useState } from 'react';
import './FileViewerScreen.css';

const FileViewerScreen = ({ fileUrl, fileName, onBack }) => {
  const [zoomLevel, setZoomLevel] = useState(100);

  return (
    <div className="file-viewer-screen">
      <div className="file-viewer-container">
        {/* Header */}
        <div className="file-viewer-header">
          <button
            className="back-button-file-viewer"
            onClick={onBack}
            title="رجوع"
          >
            ← رجوع
          </button>
          <h2 className="file-viewer-title">{fileName}</h2>
        </div>

        {/* Zoom Controls */}
        <div className="file-viewer-controls">
          <div className="zoom-controls">
            <button
              onClick={() => setZoomLevel(prev => Math.max(25, prev - 25))}
              className="zoom-button"
              title="تصغير"
            >
              −
            </button>
            <span className="zoom-level">{zoomLevel}%</span>
            <button
              onClick={() => setZoomLevel(prev => Math.min(200, prev + 25))}
              className="zoom-button"
              title="تكبير"
            >
              +
            </button>
            <button
              onClick={() => setZoomLevel(100)}
              className="zoom-reset-button"
              title="إعادة تعيين"
            >
              🔄
            </button>
          </div>
          
          {/* Zoom Slider */}
          <div className="zoom-slider-container">
            <input
              type="range"
              min="25"
              max="200"
              step="5"
              value={zoomLevel}
              onChange={(e) => setZoomLevel(Number(e.target.value))}
              className="zoom-slider"
            />
          </div>
        </div>

        {/* File Content */}
        <div className="file-viewer-content">
          <div 
            className="file-zoom-wrapper"
            style={{
              transform: `scale(${zoomLevel / 100})`,
              transformOrigin: '0 0',
              width: `${10000 / zoomLevel}%`,
              height: `${10000 / zoomLevel}%`,
              transition: 'transform 0.2s ease'
            }}
          >
            <iframe
              src={fileUrl}
              className="file-iframe"
              title="File Viewer"
              allow="fullscreen"
              onError={(e) => {
                console.error('[FileViewer] خطأ في تحميل iframe:', fileUrl);
              }}
              onLoad={() => {
                if (process.env.NODE_ENV === 'development') {
                  console.log('[FileViewer] تم تحميل iframe بنجاح:', fileUrl);
                }
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileViewerScreen;

